import script from "./PreviewModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PreviewModal.vue?vue&type=script&setup=true&lang=js"

import "./PreviewModal.vue?vue&type=style&index=0&id=218a6beb&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-218a6beb"]])

export default __exports__